<template>
  <div
    v-if="visible"
    ref="tooltipElement"
    class="tooltip"
    :style="tooltipStyle"
    @mouseenter="$emit('mouseenter')"
    @mouseleave="$emit('mouseleave')"
  >
    <!-- 注释标题栏保留代码（按要求不删除） -->
    <!--
    <div class="tooltip-header">
      <div class="header-icon">✦</div>
      <div class="header-title">{{ title }}</div>
    </div>
    -->

    <!-- 内容区域 -->
    <div class="tooltip-content" @click.stop>
      <div v-for="(item, index) in items" :key="index" class="tooltip-item" :class="{ 'tooltip-item-alarm': item.hasAlarm, 'tooltip-item-blink': item.blinkAlarm }">
        <!-- 根据类型显示不同格式 -->
        <div v-if="['planet', 'star', 'midpoint', 'axis', 'constellation', 'signLabel', 'houseSector', 'tianyun'].includes(item.type)" class="item-line">
          <div class="item-main-line">
            <strong :style="{ color: item.color }">{{ item.name }}</strong>
            {{ item.details }}
            <span class="remark-trigger" @click.stop="toggleRemark(index)">[备注]</span>
          </div>
          <div v-if="remarkVisibleIndex === index" class="remark-panel">
            <div v-if="editingIndex !== index" class="remark-display">
              {{ item.remark || '暂无备注' }}
            </div>
            <div v-if="editingIndex !== index" class="remark-actions">
              <button class="remark-action-btn" @click.stop="toggleEdit(item, index)">{{ item.remark ? '修改备注' : '新增备注' }}</button>
            </div>
            <div v-else class="remark-edit" style="margin-top: 5px;">
              <textarea
                ref="remarkTextarea"
                v-model="editRemarkText"
                placeholder="请输入备注"
                @keyup.enter.ctrl="saveRemark(item)"
                style="width: 100%; box-sizing: border-box; height: 80px; padding: 8px; font-size: 14px; border: 1px solid #ccc; border-radius: 4px; font-family: '楷体'; resize: vertical; display: block; color: #000;"
              ></textarea>
              <div style="margin-top: 5px; display: flex; justify-content: flex-end;">
                <span style="font-size: 11px; color: #666; margin-right: auto;">Ctrl+Enter 保存</span>
                <button @click.stop="saveRemark(item)" style="padding: 2px 8px; font-size: 12px; cursor: pointer; background: #2980b9; color: white; border: none; border-radius: 3px;">保存</button>
                <button @click.stop="cancelEdit" style="margin-left: 5px; padding: 2px 8px; font-size: 12px; cursor: pointer; background: #e0e0e0; color: #333; border: 1px solid #bbb; border-radius: 3px;">取消</button>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="item-line">
          <strong :style="{ color: item.color }">{{ item.name }}</strong>
          {{ item.displayText }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const { resolveTooltipLayout } = require('../../utils/tooltipGuards')

export default {
  props: {
    visible: Boolean,
    position: Object,
    items: Array,
    movement: {
      type: Object,
      default: () => ({ x: 0, y: 0 })
    }
  },
  data () {
    return {
      tooltipWidth: 0,
      tooltipHeight: 0,
      remarkVisibleIndex: null,
      editingIndex: null,
      editRemarkText: ''
    }
  },
  watch: {
    visible (newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.updateTooltipSize()
        })
      } else {
        this.remarkVisibleIndex = null
        this.editingIndex = null
        this.editRemarkText = ''
      }
    },
    items: {
      deep: true,
      handler () {
        this.$nextTick(() => {
          this.updateTooltipSize()
        })
      }
    },
    editingIndex (newVal) {
      this.$emit('editing-change', newVal !== null)
    }
  },
  computed: {
    tooltipStyle () {
      if (!this.position) return {}

      const layout = resolveTooltipLayout({
        anchor: this.position,
        tooltipSize: {
          width: this.tooltipWidth,
          height: this.tooltipHeight
        },
        viewport: {
          width: window.innerWidth,
          height: window.innerHeight
        },
        movement: this.movement
      })

      return {
        left: `${layout.left}px`,
        top: `${layout.top}px`
      }
    }
  },
  // 注释计算属性保留代码（按要求不删除）
  /*
  computed: {
    title () {
      if (this.items.length === 0) return '信息'
      return this.items[0].type === 'aspect'
        ? '相位信息'
        : '行星信息'
    }
  }
  */
  methods: {
    toggleRemark (index) {
      if (this.remarkVisibleIndex === index && this.editingIndex !== index) {
        this.remarkVisibleIndex = null
        return
      }
      this.remarkVisibleIndex = index
      this.$nextTick(() => {
        this.updateTooltipSize()
      })
    },
    toggleEdit (item, index) {
      if (this.editingIndex === index) {
        this.editingIndex = null
        return
      }
      this.remarkVisibleIndex = index
      this.editingIndex = index
      this.editRemarkText = item.remark || ''
      this.$nextTick(() => {
        this.updateTooltipSize()
        if (this.$refs.remarkTextarea) {
          const el = Array.isArray(this.$refs.remarkTextarea)
            ? this.$refs.remarkTextarea[0]
            : this.$refs.remarkTextarea
          if (el && el.focus) el.focus()
        }
      })
    },
    cancelEdit () {
      this.editingIndex = null
      this.$nextTick(this.updateTooltipSize)
    },
    saveRemark (item) {
      const newRemark = this.editRemarkText.trim()
      console.log('预留：向后台发送备注请求', { id: item.id, type: item.type, remark: newRemark })

      const updatedItem = { ...item, remark: newRemark }
      this.remarkVisibleIndex = this.editingIndex
      this.editingIndex = null
      this.$emit('save-remark', updatedItem)
      this.$nextTick(this.updateTooltipSize)
    },
    updateTooltipSize () {
      if (this.$refs.tooltipElement) {
        this.tooltipWidth = this.$refs.tooltipElement.clientWidth
        this.tooltipHeight = this.$refs.tooltipElement.clientHeight
      }
    }
  }
}
</script>

<style scoped>
.tooltip {
  position: fixed;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(4px);
  border: 1px solid #34495e;
  border-radius: 6px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);
  padding: 0;
  max-width: 500px;
  pointer-events: auto;
  font-family: '楷体';
  overflow: visible;
}

.tooltip-content {
  max-height: 400px;
  overflow-y: auto;
  padding: 6px 12px;
  scrollbar-width: thin;
  scrollbar-color: #9b59b6 #f0f0f0;
}

.tooltip-content::-webkit-scrollbar {
  width: 6px;
}

.tooltip-content::-webkit-scrollbar-track {
  background: #f0f0f0;
  border-radius: 3px;
}

.tooltip-content::-webkit-scrollbar-thumb {
  background: #9b59b6;
  border-radius: 3px;
}

.tooltip-item {
  padding: 4px 0;
  border-bottom: 1px solid #eee;
}

.tooltip-item-alarm {
  background: rgba(231, 76, 60, 0.06);
}

.tooltip-item-blink {
  animation: tooltipAlarmBlink 1s step-end infinite;
}

.tooltip-item:last-child {
  border-bottom: none;
}

.item-line {
  font-size: 14px;
  font-family: '楷体';
  color: #2c3e50;
  white-space: pre-wrap;
  word-break: break-all;
}

.item-main-line {
  display: inline-block;
}

.alarm-line {
  margin-top: 6px;
  padding: 4px 6px;
  border-radius: 4px;
  background: rgba(231, 76, 60, 0.12);
  color: #c0392b;
  font-size: 12px;
  line-height: 1.5;
  white-space: pre-wrap;
}

.alarm-blink {
  animation: tooltipAlarmBlink 1s step-end infinite;
}

@keyframes tooltipAlarmBlink {
  0%, 50% {
    opacity: 1;
    box-shadow: 0 0 0 1px rgba(231, 76, 60, 0.18);
  }
  51%, 100% {
    opacity: 0.45;
    box-shadow: 0 0 0 1px rgba(231, 76, 60, 0.45);
  }
}

.remark-trigger {
  margin-left: 6px;
  color: #000;
  font-size: 13px;
  font-weight: normal;
  font-family: '楷体';
  cursor: pointer;
  display: inline-block;
}

.remark-panel {
  margin-top: 6px;
  padding: 6px 8px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.9);
}

.remark-display {
  color: #000;
  font-size: 13px;
  line-height: 1.5;
  white-space: pre-wrap;
}

.remark-actions {
  margin-top: 6px;
}

.remark-action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px 8px;
  min-height: 22px;
  font-size: 11px;
  line-height: 1.2;
  cursor: pointer;
  color: #333;
  background: #f3f3f3;
  border: 1px solid #bdbdbd;
  border-radius: 3px;
  font-family: '楷体';
}

.remark-action-btn:hover {
  background: #e7e7e7;
}

strong {
  font-weight: bold;
  font-size: 15px;
  font-family: '楷体';
}
</style>
